import { PermissionType } from '/types/permissionTypes';
import { AnyUserType, isSimpleUserType } from '/types/userTypes';

const userHasPermission = (
    user: AnyUserType | undefined,
    permission: PermissionType
): boolean => {
    if (!user || isSimpleUserType(user)) return false;
    return user.permissions.includes(permission);
};

export default userHasPermission;
